import { render, staticRenderFns } from "./CompareModal3.vue?vue&type=template&id=44b00d91"
import script from "./CompareModal3.vue?vue&type=script&lang=js"
export * from "./CompareModal3.vue?vue&type=script&lang=js"
import style0 from "./CompareModal3.vue?vue&type=style&index=0&id=44b00d91&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports